'use client';

import { useCallback, useEffect, useState } from 'react';

import { Box, Icon } from '@chakra-ui/react';
import { MarketingHeader } from '@m/components-ui/marketing-header';
import { PageHeader } from '@m/components-ui/page-header';
import { breakpoints } from '@m/components-ui/theme';
import { APP_STORE_URL } from '@m/constants/Contacts';
import { Close, Menu } from '@m/icons';

import { ABOUT_HREF, SIGN_IN_URL } from '@/constants/links';

import { MobileMenu } from './MobileMenu';

const MD_BREAKPOINT_QUERY = `(min-width: ${breakpoints.md})`;

export function SiteHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = useCallback(() => setIsMenuOpen(false), []);
  const toggleMenu = useCallback(() => setIsMenuOpen((open) => !open), []);

  useEffect(() => {
    if (!isMenuOpen) return undefined;
    const mql = window.matchMedia(MD_BREAKPOINT_QUERY);
    const onChange = (e: MediaQueryListEvent) => {
      if (e.matches) setIsMenuOpen(false);
    };
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [isMenuOpen]);

  return (
    <>
      {/* Desktop */}
      <Box hideBelow="md" position="sticky" top="0" zIndex="banner" bg="fill.background.default">
        <MarketingHeader
          aboutHref={ABOUT_HREF}
          getTheAppHref={APP_STORE_URL}
          signInHref={SIGN_IN_URL}
        />
      </Box>

      {/*
        While the menu is open, keep the header above the dialog (modal = 1400)
        so the hamburger/X toggle remains tappable.
      */}
      <Box
        as="nav"
        hideFrom="md"
        position="sticky"
        top="0"
        zIndex={isMenuOpen ? 'skipNav' : 'banner'}
        bg="fill.background.default"
      >
        <PageHeader
          leftIcon={
            <Icon
              as={isMenuOpen ? Close : Menu}
              width={8}
              height={8}
              color="text.primary"
              aria-hidden
            />
          }
          onLeftIconClick={toggleMenu}
          rightAction={{
            href: SIGN_IN_URL,
            label: 'Log in',
            target: '_blank',
          }}
        />
      </Box>

      {isMenuOpen && <MobileMenu onClose={closeMenu} />}
    </>
  );
}
